<template>
  <button class="sidebar-minimizer for-top" type="button" @click="sidebarMinimize();brandMinimize()"></button>
</template>
<script>

export default {
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize () {
      document.body.classList.toggle('sidebar-minimized')
      window.dispatchEvent(new Event('resize')); // 강제로 resize 이벤트 발생시키기
    },
    brandMinimize () {
      document.body.classList.toggle('brand-minimized')
    }
  }
}
</script>

<style scoped>
.for-top {
  margin-top:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarMinimizer.vue